import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../Helper/ToastMessage";


// Get Table Data
export const GardenDashMainCountDataAPI = createAsyncThunk("GardenDashMainCountData", async ({ data }) => {
    const {
        M_FinancialYearID,
        M_WardID,
        M_MonthID,
        M_UserID,
        Flag,
        token,
        handleGetCount
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_GD_MainCount_Select?M_FinancialYearID=${M_FinancialYearID ? M_FinancialYearID : '0'}&M_MonthID=${M_MonthID ? M_MonthID : '0'}&M_WardID=${M_WardID ? M_WardID : '1'}&M_UserID=${M_UserID}&Flag=${Flag}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleGetCount(result.data.table)
                return result.data
            } else {
                return result
            }
        })
})

const GardenDashMainCountDataSlice = createSlice({
    name: "GardenDashMainCountData",
    initialState: {
        isLoading: false,
        GardenDashCountData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(GardenDashMainCountDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(GardenDashMainCountDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.GardenDashCountData = action.payload;
        });
        builder.addCase(GardenDashMainCountDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.GardenDashCountData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const GardenDashMainCountDataReducer = GardenDashMainCountDataSlice.reducer




export const Get_M_Asset_GeoTagging_SelectDataAPI = createAsyncThunk("Get_M_Asset_GeoTagging_SelectData", async ({ data }) => {
    const {
        M_GD_SectorID,
        M_UsersID,
        token,
        From,
        To,
        M_AssetTypeID,
        M_WardID,
        M_AssetID,
        handleResponse
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/Master/Get_M_Asset_GeoTagging_Select?M_AssetID=${M_AssetID}&M_AssetTypeID=${M_AssetTypeID}&M_WardID=${M_WardID}&M_GD_SectorID=${M_GD_SectorID}&M_UsersID=${M_UsersID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleResponse(result?.data?.table)
                return result.data
            } else {
                return result
            }
        })
})

const Get_M_Asset_GeoTagging_SelectDataSlice = createSlice({
    name: "Get_M_Asset_GeoTagging_SelectData",
    initialState: {
        isLoadinglocation: false,
        locationData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(Get_M_Asset_GeoTagging_SelectDataAPI.pending, (state, action) => {
            state.isLoadinglocation = true;
        });
        builder.addCase(Get_M_Asset_GeoTagging_SelectDataAPI.fulfilled, (state, action) => {
            state.isLoadinglocation = false;
            state.locationData = action.payload;
        });
        builder.addCase(Get_M_Asset_GeoTagging_SelectDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoadinglocation = false;
            state.isError = true;
            state.locationData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const Get_M_Asset_GeoTagging_SelectDataReducer = Get_M_Asset_GeoTagging_SelectDataSlice.reducer